import { ItineraryCheckupErrors } from './../itinerary-checker.service';
import { Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itinerary-review-checkup-dialog',
  templateUrl: './itinerary-review-checkup-dialog.component.html',
  styleUrls: ['./itinerary-review-checkup-dialog.component.css']
})
export class ItineraryReviewCheckupDialogComponent implements OnInit {

  isPreviewChecked = false;

  constructor(private matDialogRef: MatDialogRef<ItineraryReviewCheckupDialogComponent>, ) { }

  ngOnInit() {
  }

  close(): void {
    this.matDialogRef.close();
  }

}
